/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Service
 */
export interface Service {
  /**
   *
   * @type {number}
   * @memberof Service
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof Service
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof Service
   */
  price?: number | null
  /**
   *
   * @type {string}
   * @memberof Service
   */
  measureUnit?: string | null
  /**
   *
   * @type {string}
   * @memberof Service
   */
  slug?: string | null
}

/**
 * Check if a given object implements the Service interface.
 */
export function instanceOfService(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function ServiceFromJSON(json: any): Service {
  return ServiceFromJSONTyped(json, false)
}

export function ServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Service {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    price: !exists(json, 'price') ? undefined : json['price'],
    measureUnit: !exists(json, 'measureUnit') ? undefined : json['measureUnit'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ServiceToJSON(value?: Service | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    price: value.price,
    measureUnit: value.measureUnit,
    slug: value.slug,
  }
}
